import { ReactNode } from 'react'

import CancelIcon from '@mui/icons-material/Cancel'
import { Chip } from '@mui/material'
import { Box } from '@mui/system'

import { MULTI_SELECT_BOX_TEST_IDS } from './MultiSelectBox.constants'

type MultiSelectValueChipProps<Option> = {
  selectedIds: string[]
  optionMap: Map<string, Option>
  formatChipOption: (option: Option) => ReactNode
  handleDelete: (e: React.MouseEvent<HTMLButtonElement>, optionId: string) => void
  disabled?: boolean
}

export const MultiSelectValueChips = <Option,>({
  selectedIds,
  optionMap,
  formatChipOption,
  handleDelete,
  disabled
}: MultiSelectValueChipProps<Option>) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        rowGap: 0.5,
        columnGap: 0.45,
        ml: -0.75
      }}
      data-testid={MULTI_SELECT_BOX_TEST_IDS.chipContainer}
    >
      {selectedIds.map((optionId) => {
        const option = optionMap.get(optionId)
        if (!option) return null

        return (
          <Chip
            key={optionId}
            label={formatChipOption(option)}
            data-value={optionId}
            size="small"
            deleteIcon={
              disabled ? undefined : <CancelIcon onMouseDown={(e) => e.stopPropagation()} />
            }
            onDelete={disabled ? undefined : (e) => handleDelete(e, optionId)}
            data-testid={MULTI_SELECT_BOX_TEST_IDS.chip(optionId)}
          />
        )
      })}
    </Box>
  )
}
